import React, { Component } from "react";
import "./App.css";
import InstructorApp from "./InstructorApp";
import { Slide } from "@mui/material";
import { SnackbarProvider } from "notistack";
import {Helmet} from "react-helmet";

import AppTheme from "./environment/client/themes/AppTheme";

let logo = require('./environment/client/logo/' + process.env.REACT_APP_CLIENT + '-logo-white.png');

class App extends Component {
  render() {
	
    return (
	
		<>
			<Helmet>
			  <title>Admin Dashboard</title>
			  <link rel="icon shortcut " href={logo} />
			  <link rel="apple-touch-icon" href={logo} />
			  <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
			  <meta http-equiv="Pragma" content="no-cache" />
			  <meta http-equiv="Expires" content="0" />
			  <meta name="viewport" content="width=device-width, initial-scale=1" />
		  </Helmet>  

      <AppTheme>
        <SnackbarProvider
          // iconVariant={{ success: "✅", error: "✖️", warning: "⚠️", info: "ℹ️" }}
          // dense={false} preventDuplicate hideIconVariant={false}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          TransitionComponent={Slide}
          maxSnack={10}
        >
		 
          <InstructorApp />
        </SnackbarProvider>
	      </AppTheme>
	</>
    );
  }
}

export default App;
